(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileDetailController', ProfileDetailController);

    ProfileDetailController.$inject = ['$scope', '$window', '$rootScope', '$state', '$stateParams', '$http', '$translate', 'previousState', 'entity', 'Profile', 'Customer', 'DataUtils', 'CustomerStatusLogs', 'Chat'];

    function ProfileDetailController($scope, $window, $rootScope, $state, $stateParams, $http, $translate, previousState, entity, Profile, Customer, DataUtils, CustomerStatusLogs, Chat) {
        var vm = this;

        vm.profile = entity;
        vm.previousState = previousState.name;
        vm.save = save;
        vm.openChat = openChat;
        vm.getCustomerChatByCustomerId = getCustomerChatByCustomerId;
        vm.getCustomerStatusLogsByCustomerId = getCustomerStatusLogsByCustomerId;
        vm.getCurrencyNameForClient = DataUtils.getCurrencyNameForClient;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:profileUpdate', function (event, result) {
            vm.profile = result;
        });

        $scope.$on('$destroy', unsubscribe);
        getCustomerStatusLogsByCustomerId();
        getCustomerChatByCustomerId();

        vm.dateOfBirth = new Date(vm.profile.customerDateOfBirth);

        loadNationalities();

        function save() {
            vm.customer = {
                id: vm.profile.customerId,
                fullName: vm.profile.customerFullName,
                status: vm.profile.customerStatus,
                dateOfBirth: vm.dateOfBirth,
                gender: vm.profile.customerGender,
                passportNumber: vm.profile.passportNumber,
                allowAnyIp: vm.profile.allowAnyIp
            };
            vm.isSaving = true;
            if (vm.profile.customerId !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            vm.profile.customerFullName = result.fullName;
            vm.profile.customerStatus = result.status;
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getCustomerChatByCustomerId() {
            Chat.getByCustomerId({customerId: vm.profile.customerId}, function (data) {
                if(!data){
                    vm.customerChat = [];
                } else {
                    vm.customerChat = data;
                }
            });
        }

        function openChat() {
            $window.open('/#/chat/' +  vm.customerChat.chatId, '_blank');
        }

        function getCustomerStatusLogsByCustomerId() {
            CustomerStatusLogs.query({customerId: vm.profile.customerId}, function (data) {
                vm.customerStatusLogs = data;
            });
        }

        function loadNationalities() {
            $http.get('i18n/' + $translate.use() + '/nationalityList.json').success(function (nationalities) {
                vm.nationalities = nationalities;
            });
        }
    }
})();
